/**
 * @desc 查询节假日列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  Array<defs.basics.HolidayManagementListRpcResponseDto>
>;
export function request(
  body: defs.basics.HolidayManagementRpcRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/holidayManagement/getHolidayList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
